module.exports = __webpack_public_path__ + "static/img/10.b96c24c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/10.png
// module id = 5Pq5
// module chunks = 0